import "./Home.scss";
import home1 from "../assets/images/home1.png";
import home2 from "../assets/images/home4.png";
import home3 from "../assets/images/home5.png";
import f1 from "../assets/images/Dekstop.png";
import f2 from "../assets/images/Printer.png";
import f3 from "../assets/images/Networking.png";
import f4 from "../assets/images/Tablet.png";

const mainCategories = [
  {
    img: f1,
    title: "Desktop",
    desc: "Acer, Lenovo, Asus, MSI",
  },
  {
    img: f2,
    title: "Printer",
    desc: "Ink & Toner, 3D Printer, 3D Scanner, Engraver",
  },
  {
    img: f3,
    title: "Networking",
    desc: "Modem / Router Modem, Wireless Router, IP / Network Camera",
  },
  {
    img: f4,
    title: "Tablet",
    desc: "Apple IPad, Microsoft Surface, Honor Pad",
  },
];

const promoCards = [
  {
    img: f1,
    title: "Desktop",
    desc: "Acer, Lenovo, Asus, MSI",
  },
  {
    img: f2,
    title: "Printer",
    desc: "Ink & Toner, 3D Printer, 3D Scanner, Engraver",
  },
  {
    img: f3,
    title: "Networking",
    desc: "Modem / Router Modem, Wireless Router, IP / Network Camera",
  },
  {
    img: f4,
    title: "Tablet",
    desc: "Apple IPad, Microsoft Surface, Honor Pad",
  },
];

function HomeContent2() {
  return (
    <section className="home-content-2">
      <div className="container">
        <div className="section-heading">
          <span className="section-kicker">DISCOVER MORE</span>
          <h2>Popular Categories</h2>
          <p>
            Shop top-quality smart devices, portable technology, and daily essentials all in one place.
          </p>
        </div>

        <div className="category-feature-grid">
          {mainCategories.map((item) => (
            <article className="feature-card large" key={item.title}>
              <img src={item.img} alt={item.title} />
              <div className="feature-overlay">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                <a href="#" className="mini-label">EXPLORE NOW</a>
                {/* <a href="#featured-products">Explore Now</a> */}
              </div>
            </article>
          ))}
        </div>

        {/* <div className="promo-mini-grid">
          {promoCards.map((item) => (
            <article className="feature-card small" key={item.title}>
              <img src={item.img} alt={item.title} />
              <div className="feature-overlay compact">
                <span className="mini-label">PROMO</span>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </article>
          ))}
        </div> */}
      </div>
    </section>
  );
}

export default HomeContent2;